import api from '../../../api'

export function mtdTracking(currentStartDate, currentEndDate, previousStartDate, previousEndDate){
    return api.get(`order-mtd-tracking?currentStartDate=${currentStartDate}&currentEndDate=${currentEndDate}&previousStartDate=${previousStartDate}&previousEndDate=${previousEndDate}`);
}

export function mtdCancellRto(currentStartDate, currentEndDate, previousStartDate, previousEndDate){
    return api.get(`order-cancellation-rto-tracking?currentStartDate=${currentStartDate}&currentEndDate=${currentEndDate}&previousStartDate=${previousStartDate}&previousEndDate=${previousEndDate}`);
}
